export enum SideBarMenuItemsSecObjects {
    LinkOffererLines = 'LinkOferenteLineas'
}

export enum AppSecObjects {
    RutaAdminMaster = 'RutaAdminMaster',
    RutaPanelAdmin = 'RutaPanelAdmin',
    RutaAdminUsuarios = 'RutaAdminUsuarios',
    RutaAdminGrupos = 'RutaAdminGrupos',
    RutaAdminEtapas = 'RutaAdminEtapas',
    RutaAdminPerfiles = 'RutaAdminPerfiles',
    RutaAdminSectoresComerciales = 'RutaAdminSectoresComerciales',
    RutaAdminEventos = 'RutaAdminEventos',
    RutaAdminUnidadesNegocio = 'RutaAdminUnidadesNegocio',
    RutaAdminReportes = 'RutaAdminReportes',
    RutaAdminReporteDetalleSistemaGrupo = 'RutaAdminReporteDetalleSistemaGrupo',
    RutaAdminClienteTipo = 'RutaAdminClienteTipo',
    RutaAdminClienteTipoRelaciones = 'RutaAdminClienteTipoRelaciones',
    RutaAdminClienteTipoLCTC = 'RutaAdminClienteTipoLCTC',
    RutaAdminClienteTipoLCTCRelaciones = 'RutaAdminClienteTipoLCTCRelaciones',
    RutaAdminSectorSistemaGrupo = 'RutaAdminSectorSistemaGrupo',
    RutaAdminEtapaEnvioMail = 'RutaAdminEtapaEnvioMail',
    RutaAdminObjetosSeguridad = 'RutaAdminObjetosSeguridad',
    RutaAdminPermisos = 'RutaAdminPermisos',
    RutaWorkflowGrafo = 'RutaWorkflowGrafo'
}

export enum AdminPanelSecObjects {
    LinkTablaUsuarios = 'LinkTablaUsuarios',
    LinkTablaGrupos = 'LinkTablaGrupos',
    LinkTablaEtapas = 'LinkTablaEtapas',
    LinkTablaPerfiles = 'LinkTablaPerfiles',
    LinkTablaSectoresComerciales = 'LinkTablaSectoresComerciales',
    LinkTablaEventos = 'LinkTablaEventos',
    LinkTablaUnidadesNegocio = 'LinkTablaUnidadesNegocio',
    LinkTablaReportes = 'LinkTablaReportes',
    LinkTablaClienteTipo = 'LinkTablaClienteTipo',
    LinkTablaClienteTipoLCTC = 'LinkTablaClienteTipoLCTC',
    LinkTablaSectorSistemaGrupo = 'LinkTablaSectorSistemaGrupo',
    LinkTablaEtapaEnvioMail = 'LinkTablaEtapaEnvioMail',
    LinkTablaObjetosSeguridad = 'LinkTablaObjetosSeguridad',
    LinkTablaPermisos = 'LinkTablaPermisos',
    LinkTablaEtapaGrupoPermiso = 'LinkTablaEtapaGrupoPermiso',
    BotonRefrescarCaches = 'BotonRefrescarCaches'
}

export enum WorkflowSecObjects {
    BotonGraficoSubyacentes = 'BotonGraficoSubyacentes'
}